import React, { FC } from "react";
import { Fade } from "react-awesome-reveal";
import classNames from "classnames";
import {
  BlockHeader,
  HeaderLevel,
} from "@app/components/common/block-header/BlockHeader";
import { BlockBody } from "@app/components/common/block-body/BlockBody";
import { IRichText, TextType } from "@app/models/storyblok/basic";
import { DEFAULT_FADE_DURATION } from "@app/constants";

type Props = {
  title: IRichText<TextType>;
  text: IRichText<TextType>;
};

export const Hero: FC<Props> = ({ title, text }) => (
  <Fade duration={DEFAULT_FADE_DURATION} triggerOnce>
    <div
      className={classNames(
        "text-primary-content flex flex-col gap-5 px-5 pt-20",
        "lg:flex-row lg:justify-between lg:gap-10 lg:px-16 lg:pt-40",
        "xl:max-w-container-wide xl:px-24",
      )}
    >
      <div className={classNames("md:w-[73%]", "lg:w-1/3", "xxl:w-1/4")}>
        <BlockHeader
          richText={title}
          headerLevel={HeaderLevel.H1}
          className={classNames(
            "text-large",
            "lg:text-xx-large",
            "xxl:text-huge",
          )}
        />
      </div>
      <div
        className={classNames(
          "text-regular",
          "lg:text-large lg:w-3/5",
          "xxl:w-2/3 xxl:text-xx-large",
        )}
      >
        <BlockBody richText={text} />
      </div>
    </div>
  </Fade>
);
